type CompanySizeDropdownItem = {
  en: string;
  zh: string;
};

const companySizes: CompanySizeDropdownItem[] = [
  {
    en: 'Less than 10',
    zh: '<10员工',
  },
  {
    en: '10-19',
    zh: '10-19员工',
  },
  {
    en: '20-49',
    zh: '20-49员工',
  },
  {
    en: '50-99',
    zh: '50-99员工',
  },
  {
    en: '100-249',
    zh: '100-249员工',
  },
  {
    en: '250-499',
    zh: '250-499员工',
  },
  {
    en: '500-999',
    zh: '500-999员工',
  },
  {
    en: '1,000-2,499',
    zh: '1000-2499员工',
  },
  {
    en: '2,500-4,999',
    zh: '2500-4999员工',
  },
  {
    en: '5,000+',
    zh: '>5000员工',
  },
];

export default companySizes;
